import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError, handleAlertBoxClick } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
export default function ClientLenders() {
    const params = useParams();
    const [lists, setLists] = useState([]);
    const [lendersLimit, setLendersLimit] = useState(0);
    const [lendersAdded, setLendersAdded] = useState(0);
    const [lendersPending, setLendersPending] = useState(0);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const onDelete = (e, id) => {
        if (window.confirm('Are you sure to delete this record?')) {
            axios.delete(config.APIACTIVATEURL + config.DELETECLIENTLENDER + "/" + id, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetData();
                    }
                    else {
                        handleError(response.data.message);
                        GetData();
                    }
                });
        }
    }
    const onAdd = (e, id) => {
        e.preventDefault();
        if (parseInt(lendersAdded) >= parseInt(lendersLimit)) {
            handleAlertBoxClick("Maximum " + lendersLimit + " funders allowed for this subscription plan. Please click on extra funder to purchase more funders")
        }
        else {
            if (window.confirm('Are you sure to add this funder?')) {
                const formData = {
                    "clientLenderId": "00000000-0000-0000-0000-000000000000",
                    "lenderId": id,
                    "clientId": localStorage.getItem("clientId")
                }
                axios.post(config.APIACTIVATEURL + config.CREATECLIENTLENDER, formData, { ...headerconfig })
                    .then((response) => {
                        if (response.data.statusCode === 200) {
                            handleSuccess("Lender added succesfully");
                            GetData();
                        }
                        else {
                            handleError("Error in adding lender");
                            GetData();
                        }
                    });
            }
        }
    }
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETCLIENTLENDERS + "/" + localStorage.getItem("clientId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLists(response.data.data);
                    setLendersLimit(response.data.lendersLimit);
                    setLendersAdded(response.data.lendersAdded);
                    setLendersPending(response.data.lendersPending);
                }
            });
    };
    useEffect(() => {
        GetData();
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header border-0">
                                    <h5> My Funders </h5>
                                    <span className="badge bg-primary fs-12">Limit: {lendersLimit} Funders</span>
                                    <span className="badge bg-success fs-12 me-2">Added : {lendersAdded}</span>
                                    <span className="badge bg-warning fs-12 me-2">Pending : {lendersPending}</span>
                                    {lendersPending===0?
                                    <Link to={"/userdashboard/add-ons"} className="badge bg-secondary fs-12 me-2">+ Add Extra Funder</Link>
                                    :""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div class="card card-body py-3">
                                <div className="table-responsive table-card">
                                    <table className="table align-middle" id="customerTable">
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Lender</th>
                                                <th>Min. Monthly</th>
                                                <th>Min. Deposit</th>
                                                <th>FICO</th>
                                                <th className="text-wrap">Restricted Industries</th>
                                                <th className="text-wrap">Restricted States</th>
                                                <th className="text-center">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className="list form-check-all">
                                            {lists.length > 0 && lists.map((v, index) =>
                                                <tr key={v.lenderId}>
                                                    <td>{index + 1}</td>
                                                    <td>{v.companyName}</td>
                                                    <td>{v.minimumMonthly}</td>
                                                    <td>{v.minimumDeposit}</td>
                                                    <td>{v.fico}</td>
                                                    <td className="text-wrap">{v.industries}</td>
                                                    <td className="text-wrap">{v.states}</td>
                                                    <td className="align-middle">  {/* Add align-middle to all tds */}
                                                        {v.isSelected === true ? (
                                                            <div className="d-flex gap-2 align-items-center">  {/* Add align-items-center */}
                                                                <button className="btn btn-sm btn-success" disabled>Added</button>
                                                                <Link
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={(e) => onDelete(e, v.clientLenderId)}
                                                                >
                                                                    Remove
                                                                </Link>
                                                            </div>
                                                        ) : (
                                                            <Link
                                                                className="btn btn-sm btn-warning"
                                                                onClick={(e) => onAdd(e, v.lenderId)}
                                                            >
                                                                Add
                                                            </Link>
                                                        )}
                                                    </td>

                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}